import { Stat } from '../../api';
import MonthBarChart from './MonthBarChart';

function getArrays(data: Stat, viewMode: string) {
  if (viewMode == 'transfer')
    return data?.frames?.bytes
      ? [
          data.frames.bytes.map((value: number) => {
            return value / 1000000;
          }),
        ]
      : [[]];
  else if (viewMode == 'notfound') return data?.frames?.notFound ? [data.frames.notFound] : [[]];
  else return data?.frames?.count ? [data.frames.count] : [[]];
}
function getTitle(viewMode: string, day: number): string {
  if (viewMode == 'transfer') return `Frame bandwidth usage (MB) by ${day ? 'hour' : 'day'}`;
  else if (viewMode == 'notfound') return `Frame download fails by ${day ? 'hour' : 'day'}`;
  else return `Frame accesses by ${day ? 'hour' : 'day'}`;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getUnit(viewMode: string, day: number | undefined): string {
  if (viewMode == 'transfer') return 'MB';
  if (viewMode == 'notfound') return 'fails';
  return 'accesses';
}

export default function MonthCameraFramesChart(props: {
  stat: Stat;
  offset: number;
  daysInMonth: number;
  viewMode: string;
  day: number;
  month: number;
  year: number;
  tz: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options?: any;
  onChangeDay: (d: number) => void;
}) {
  return <MonthBarChart getUnit={getUnit} getTitle={getTitle} getArrays={getArrays} {...props} />;
}
